import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APP_TOP_LEVEL_PATH } from '@epicuro-next/navigation/constants';
import { getPulseUIRedirectTo } from '@epicuro-next/utilities-browser';

@Injectable()
export class UrlResolverGuard {
  constructor(private router: Router) {}

  public canActivate() {
    const redirectTo = getPulseUIRedirectTo();

    if (redirectTo?.includes(APP_TOP_LEVEL_PATH.urlResolver.path)) {
      return this.router.parseUrl(`/${redirectTo}`);
    }

    return true;
  }
}
